import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Event } from 'xstate';
import { Button } from '@material-ui/core';

import { darkPurple } from 'utils/color-styles';
import { BackButton } from 'components/BackButton/BackButton';

export interface PrevNextButtonsProps {
  sendPrev?: (event: Event<any>) => void;
  sendNext?: (event: Event<any>) => void;
  isPrevTransitionAllowed?: (event: string) => boolean;
  isNextTransitionAllowed?: (event: string) => boolean;
}

export const PrevNextButtons = ({
  isPrevTransitionAllowed,
  isNextTransitionAllowed,
  sendPrev,
  sendNext,
}: PrevNextButtonsProps): JSX.Element => (
  <div style={{ color: darkPurple }}>
    {isPrevTransitionAllowed?.('PREV') && (
      <BackButton onClick={(): unknown => sendPrev?.('PREV')} />
    )}
    {isNextTransitionAllowed?.('NEXT') && (
      <Button
        color="inherit"
        type="button"
        endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
        style={{ marginRight: 8 }}
        onClick={(): unknown => sendNext?.('NEXT')}
      >
        Next
      </Button>
    )}
  </div>
);

export default PrevNextButtons;
